// IconButton with Tooltip wrapper component for reuse across the app

import { IconButton, Tooltip } from "@mui/material";

type ToolTipIconButtonProps = {text: string; icon: React.ReactNode; onClick: () => void};

export const ToolTipIconButton = ({text, icon, onClick}: ToolTipIconButtonProps) => {

    return(
        <Tooltip title={text}>
            <IconButton onClick={onClick}>
                {icon}
            </IconButton>
        </Tooltip>
    );
};